var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRegistrationForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8515 62.3039L21.7963 62.259L21.8141 18.0591L24.8693 18.104L24.8515 62.3039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87985 33.214L71.3799 33.3038L71.3963 30.1038L8.89627 30.014L8.87985 33.214Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9418 21.4019H70.4418V21.4007L73.9418 21.4007C73.9411 18.2051 71.3335 15.5979 68.1378 15.5979H11.804C8.60784 15.5979 6 18.2059 6 21.402L6.00282 58.9581C6.0029 62.1542 8.61083 64.7619 11.8068 64.762L68.1642 64.7706C71.3603 64.7706 73.9682 62.1627 73.9682 58.9666L73.9418 21.4019ZM9.5 21.4018L9.50232 26H70.4418V21.4019L9.5 21.4018ZM9.5 21.4018L70.4418 21.4007C70.4412 20.1381 69.4006 19.0979 68.1378 19.0979H11.804C10.5409 19.0979 9.50007 20.1387 9.5 21.4018ZM70.4418 26L70.451 34.561L70.4533 37.761L70.4682 58.9666C70.4677 60.2292 69.4272 61.2704 68.1645 61.2706L11.8071 61.262C10.5439 61.262 9.50282 60.2212 9.50282 58.958L9.50123 37.761L9.50099 34.561L9.5 28.5L9.50232 26H70.4418ZM21.7963 62.259L24.8515 62.3039L24.8693 18.104L21.8141 18.0591L21.7963 62.259ZM71.3799 33.3038L8.87985 33.214L8.89627 30.014L71.3963 30.1038L71.3799 33.3038Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegistrationForm);
export default __webpack_public_path__ + "static/media/Icon-registration_form.bc475936d6c6001e9f6b58211e65f899.svg";
export { ForwardRef as ReactComponent };